import { Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";

export const classes: Record<string, SystemStyleObject<Theme>> = {
  tabs: {
    ".MuiTabs-indicator": {
      background: "linear-gradient(90deg, #5C61FF 0%, #9366FF 100%)",
    },

    ".MuiTab-root": {
      color: "primary.main",

      "&.Mui-selected": {
        color: "common.white",
      },
    },
  },
};
